import { FieldData, Highlight, Point } from "./types";

export const convertToHighlights = (fields: Record<string, FieldData>): Highlight[] => {
  return Object.entries(fields).map(([fieldName, field]) => ({
    fieldName,
    value: field.value,
    page: field.page,
    boundingBox: field.boundingBox as [Point, Point, Point, Point]
  }));
};
